/* @flow */

import React from 'react';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import ButtonComponent from 'components/buttons/button';
import IntlMessageComponent from 'components/formatters/intlMessage';

type BankAccountCountryMismatchDialogComponentProps = {
  open: boolean;
  onClose: () => void;
  onSubmit: (reason: string) => void;
}

type BankAccountCountryMismatchDialogComponentState = {
  reason: string;
  reasonError: boolean;
}

export default class BankAccountCountryMismatchDialogComponent extends React.Component<BankAccountCountryMismatchDialogComponentProps, BankAccountCountryMismatchDialogComponentState> {
  constructor(props: BankAccountCountryMismatchDialogComponentProps) {
    super(props);

    this.state = {
      reason: '',
      reasonError: false
    };
  }

  handleReasonChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    this.setState({
      reason: event.target.value,
      reasonError: false
    });
  };

  handleSubmit = () => {
    const reason = this.state.reason.trim();

    if (reason.length < 3) {
      this.setState({ reasonError: true });
      return;
    }

    this.props.onSubmit(reason);
  };

  render() {
    return (
      <Dialog open={this.props.open} onClose={this.props.onClose} fullWidth maxWidth="sm">
        <DialogTitle>
          <IntlMessageComponent id="component.bankaccount.countrymismatch.title" />
        </DialogTitle>

        <DialogContent>
          <Typography variant="body1">
            <IntlMessageComponent id="component.bankaccount.countrymismatch.message" />
          </Typography>

          <TextField
            id="form.bankAccountCountryMismatchReason"
            label={<IntlMessageComponent id="component.bankaccount.countrymismatch.reason" />}
            value={this.state.reason}
            onChange={this.handleReasonChange}
            error={this.state.reasonError}
            helperText={
              this.state.reasonError
                ? <IntlMessageComponent id="component.bankaccount.countrymismatch.reason.invalid" />
                : ''
            }
            fullWidth
            margin="normal"
            multiline
            rows={3}
            required
          />
        </DialogContent>

        <DialogActions>
          <ButtonComponent color="default" onClick={this.props.onClose}>
            <IntlMessageComponent id="general.cancel" />
          </ButtonComponent>

          <ButtonComponent color="primary" onClick={this.handleSubmit}>
            <IntlMessageComponent id="general.submit" />
          </ButtonComponent>
        </DialogActions>
      </Dialog>
    );
  }
}